export const NOTIFICATION_TOAST_ALIAS_MAP = {
  success: 'success',
  warning: 'warning',
  error: 'danger',
  danger: 'danger',
  primary: 'primary',
};

export const DEFAULT_NOTIFICATION_TOAST_STATUS = 'primary';
